import React, { useEffect } from 'react'
import ReportsFilter from './ReportsFilter'
import Totals from './Totals'
import {
	fetchTotals,
	fetchCommission,
	fetchUnengagedUsers,
	fetchChurnedCustomers,
	fetchProductMix,
	fetchdocumentHistoriesEngagementChart,
	fetchUsersEngagementChart,
	fetchDocumentsEngagementChart,
	fetchStores,
	fetchReportCustomers,
} from './reports.asynActions'
import { useDispatch, useSelector } from 'react-redux'
// Removed react-bootstrap layout components in favor of Tailwind layout
import EngagementChart from './EngagementChart'
import Commission from './Commission'
import UnengagedUsers from './UnengagedUsers'
import ChurnedCustomers from './ChurnedCustomers'
import ProductMixChart from './ProductMixChart'
import {
	selectFilters,
	selectPreviousFilters,
	selectIsDateSelected,
} from './reports.selectors'
import { setPreviousFilters, resetEngagementChart } from './reports.slice'
import { isEqual } from 'lodash'
import { fetchAccountUsers } from '../Account'
import { selectIsAdmin } from '../Profile/profile.selectors'
import moment from 'moment/moment'

const ZERO_DAYS = 0

const Reports = () => {
	const dispatch = useDispatch()
	const filters = useSelector(selectFilters)
	const isDateSelected = useSelector(selectIsDateSelected)
	const startDate = moment(filters.startDate)
	const endDate = moment(filters.endDate)
	const previousFilters = useSelector(selectPreviousFilters)
	const isFilterChange = !isEqual(filters, previousFilters)
	const isAdmin = useSelector(selectIsAdmin)
	const daysDifference = endDate.diff(startDate, 'days')
	
	useEffect(() => {
		dispatch(setPreviousFilters(filters))
		if (isFilterChange) {
			dispatch(resetEngagementChart())
			dispatch(fetchTotals({ filters, useCaching: isFilterChange }))
			if (daysDifference > ZERO_DAYS || isDateSelected) {
				dispatch(
					fetchdocumentHistoriesEngagementChart({
						filters,
						useCaching: isFilterChange,
					})
				)
				dispatch(
					fetchUsersEngagementChart({ filters, useCaching: isFilterChange })
				)
				dispatch(
					fetchDocumentsEngagementChart({
						filters,
						useCaching: isFilterChange,
					})
				)
			}
			dispatch(fetchProductMix({ filters, useCaching: isFilterChange }))
			dispatch(fetchCommission({ filters, useCaching: isFilterChange }))
			dispatch(fetchUnengagedUsers({ filters, useCaching: isFilterChange }))
			dispatch(fetchChurnedCustomers({ filters, useCaching: isFilterChange }))
		}
	}, [dispatch, filters, isFilterChange, daysDifference, isDateSelected])

	useEffect(() => {
		isAdmin && dispatch(fetchAccountUsers())
		filters.customer && dispatch(fetchStores(filters.customer))
	}, [dispatch, isAdmin, filters.customer])

	useEffect(() => {
		dispatch(fetchReportCustomers())
	}, [dispatch])

	return (
			<div className='w-full px-4 pt-4'>
				<div className='grid gap-2 xl:grid-cols-12 items-stretch mb-15'>
					<div className='xl:col-span-12 lg:col-span-12'>
						<ReportsFilter />
					</div>
					<div className='xl:col-span-12 lg:col-span-12'>
						<Totals />
					</div>
					<div className='xl:col-span-6 lg:col-span-6 flex flex-col mb-15 gap-4 h-full'>
						<EngagementChart />
					</div>
					<div className='xl:col-span-6 lg:col-span-6 flex flex-col mb-15 gap-4 h-full'>
						<ProductMixChart />
					</div>
					<div className='xl:col-span-12 lg:col-span-12 flex flex-col mb-15 gap-4 h-full'>
						<Commission />
					</div>
					<div className='xl:col-span-6 lg:col-span-6'>
						<UnengagedUsers />
					</div>
					<div className='xl:col-span-6 lg:col-span-6'>
						<ChurnedCustomers />
					</div>
				</div>
			</div>
	)
}

export default Reports
